<template>
  <div v-if="!showBranding">
    <breadCrumb :icon="'fa-chart-area'" :category="$t(`sideNav.navDashboard`)" :subCategory="''" :subSubCategory="''">
    </breadCrumb>
    <div class="text-right mt-3 mr-5">
      <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" @click="showBranding = !showBranding">
        <span class="fal fa-home mr-2"></span>
        <span>{{ $t("button_link.view") }}{{ $t("subMenu.my_salon_branding") }}</span>
      </button>
    </div>
    <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5" role="tablist">
      <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.dashboardTab" :key="t.id">
        <a class="nav-link bg-transparent fs-lg fw-400" :class="{ active: selectedTab == t.id }" @click="selectedTab = t.id">{{ t.text }}</a>
      </li>
    </ul>
    <div class="px-3 px-sm-5 py-4">
      <!-- <div v-show="false" class="d-flex">
        <multiselect
          :value="selectedOutlet"
          label="text"
          track-by="id"
          :options="outlet"
          :searchable="false"
          :show-labels="false"
          openDirection="below"
          class="col-3"
        >
          <template slot="option" slot-scope="{ option }">{{
            option.text
          }}</template>
        </multiselect>
      </div> -->
      <dashboardInfoFilter :selectedThisYear="selectedThisYear" :selectedLastYear="selectedLastYear" :selectedOutlet="selectedOutlet" :outlet="outlet"
                           @filterDashboard="filterDashboard">
      </dashboardInfoFilter>
      <div class="tab-content mt-3">
        <dashboardSalesSummary :class="{ active: selectedTab == 'sales' }" class="tab-pane" ref="dashboardSalesSummary"></dashboardSalesSummary>
      </div>
    </div>
    <div :class="{ show: showLoadingModal }" class="modal fade">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-body text-center">
            <div class="spinner-border text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div class="text-light mt-2">
              {{ $t("message.data.fetching_wait") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <dashboardBrandLanding v-else @returnDashboard="returnDashboard"></dashboardBrandLanding>
</template>
<script>
import BreadCrumb from "./../dashboard/Bread_Crumb";
import DashboardInfoFilter from "./Dashboard_Info_Filter";
import DashboardSalesSummary from "./Dashboard_Sales_Summary.new";
import DashboardBrandLanding from "./Dashboard_Brand_Landing";
import { getOutletList, handleSessionExpired } from "./../../assets/js/dashboard/dashboard";
import moment from "moment";

export default {
  name: "dashboardInfo",
  components: {
    DashboardBrandLanding,
    DashboardSalesSummary,
    DashboardInfoFilter,
    BreadCrumb,
  },
  data() {
    let time = moment()

    return {
      selectedTab: "sales",
      showLoadingModal: false,
      showBranding: false,

      selectedThisYear: time.get('year'),
      selectedLastYear: time.subtract(1, 'year').get('year'),
      selectedOutlet: {},
      outlet: [],
    };
  },
  methods: {
    returnDashboard() {
      this.showBranding = false;
    },

    async filterDashboard(filterObj) {
      this.selectedThisYear = filterObj.thisYear
      this.selectedLastYear = filterObj.lastYear
      this.selectedOutlet = filterObj.outlet

      this.$refs.dashboardSalesSummary.filterData(this.selectedThisYear, this.selectedLastYear, this.selectedOutlet);
      // this.loadSalesItems()
    },
    async loadSalesItems() {
      this.showLoadingModal = true;
      var tyObjDate = {
        startDate: "01/01/" + this.selectedThisYear,
        endDate: "31/12/" + this.selectedThisYear,
      };
      var thisYear = await this.getSalesItems(tyObjDate, this.selectedOutlet);
      var tyObj = {
        date: this.selectedThisYear,
        data: thisYear,
      };

      var lyObjDate = {
        startDate: "01/01/" + this.selectedLastYear,
        endDate: "31/12/" + this.selectedLastYear,
      };
      var lastYear = await this.getSalesItems(lyObjDate, this.selectedOutlet);
      var lyObj = {
        date: this.selectedLastYear,
        data: lastYear,
      };

      this.$refs.dashboardSalesSummary.setSummaryData(tyObj, lyObj);
      this.showLoadingModal = false;
    },
    async getSalesItems(date, outlet) {
      let $vm = this;
      var outletFilter = outlet == "all" ? "" : "&outletID=" + outlet;
      let QUERY_STRING =
        "?startDate=" +
        date.startDate +
        "&endDate=" +
        date.endDate +
        outletFilter;

      const url = this.$api.REPORT_COMPLETED + QUERY_STRING;
      var result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$axios.defaults.baseURL,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.result;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
  },
  mounted() {
    let $vm = this;

    var blockList = JSON.parse(JSON.stringify($vm.$store.state.blockList));
    $vm.showBranding = blockList.indexOf("biz.report.*") == -1 ? false : true;

    $vm.outlet = JSON.parse($vm.$store.state.outlets);
    $vm.outlet.unshift({ id: "all", text: $vm.$i18n.t('label.all', { 'item': $vm.$i18n.t('label.outlet') }) })
    $vm.selectedOutlet = $vm.outlet[0];

    // this.$refs.dashboardSalesSummary.filterSet(this.selectedThisYear, this.selectedLastYear, this.selectedOutlet);
    // this.loadSalesItems()
  },
};
</script>
<style scoped>
.show {
  display: block;
}

.modal-content {
  background: transparent;
  box-shadow: none;
}
</style>